/**
 * Which rows an empty week should open with (FR2, "Previous activity visualization").
 *
 * Filling in a timesheet means typing the same handful of numbers against the same handful of
 * project/activity pairs every week. Opening a new week on an empty grid makes you pick a project
 * and an activity before you can type a single one of them. So an empty week starts with the pairs
 * you booked to most recently, and you type straight into the cells.
 *
 * These are keys for the grid's `keepRows`, the same mechanism the "add row" form uses: a row with
 * no stored entry behind it. Nothing is written to the database until a cell is actually filled,
 * so a week you open and leave alone stays empty and a seeded row you ignore costs nothing.
 *
 * `recent` comes from `GET /me/options` — up to ten pairs, newest first, already filtered to ones
 * still active and still selectable by that user, so an archived project cannot come back this way.
 */
export function previousActivityRows(
  enabled: boolean,
  week: { rows: unknown[] } | undefined,
  recent: { projectId: string; activityId: string }[] | undefined,
): string[] {
  if (!enabled || !week || !recent) return [];
  // Only a week with nothing in it. A week you have started is one you are already shaping, and
  // adding rows to it would put back the row you just deleted.
  if (week.rows.length > 0) return [];
  return recent.map((r) => `${r.projectId}:${r.activityId}`);
}
